<template>
  <div class="customer-container">
    <Breadcrumb :company="company_uid" :project="projectUID" lastname="Customer List"/>    
    <CustomerManager v-if="projectUID" :projectUID="projectUID"/>
    <el-card class="box-card" v-if="!projectUID">
      <el-alert
        title="Error alert"
        type="error"
        description="Pleace select your project"
        show-icon
        :closable="false">
      </el-alert>
      <el-button @click="$router.push('/project')" type="primary">Select your Project</el-button>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getProjectBy } from "@/api/project"
import CustomerManager from "@/views/customer/components/customer-manager";
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    CustomerManager,
    Breadcrumb
  },
   computed:{
    ...mapGetters(['user_project','company_uid', 'company_name'])
  },
  data() {
    return {
      projectUID: "",
      projectInfo: {},
    };
  },
  methods: {
    getProjectInfo() {
      const loading = this.$notifyloading("Loading data...");
      this.projectUID = this.user_project;
      getProjectBy(this.projectUID).then(({ result, data }) => {
        loading.close();
        if (result) {
          this.projectInfo = data;
        }
      });
    },
  },

  created() {
    this.projectUID = this.user_project
    // this.getProjectInfo();
  },
};
</script>

<style>
</style>